import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["chars", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
var styles = {
  "effect": "Placeholder-effect_1YLEe",
  "move": "Placeholder-move_3_r_P",
  "root": "Placeholder-root_G1eL2 Placeholder-effect_1YLEe"
};
function Placeholder(_ref) {
  var _ref$chars = _ref.chars,
    chars = _ref$chars === void 0 ? 3 : _ref$chars,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      tagName: "span",
      style: {
        minWidth: "".concat(chars, "ch")
      },
      className: clsx(styles.root, className)
    }, extraProps))
  );
}
export default Placeholder;